// extracted by mini-css-extract-plugin
export default {"root":"FormTemplate_root__SMzBp","placeHolderShimmer":"FormTemplate_placeHolderShimmer__VOlC3"};